import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 在这里定义您的状态
    // 例如: user: null,
    // token: localStorage.getItem('token') || ''
  },
  mutations: {
    // 在这里定义您的 mutations (同步更改状态)
    // 例如: SET_USER(state, user) { state.user = user; },
    // SET_TOKEN(state, token) { state.token = token; localStorage.setItem('token', token); }
  },
  actions: {
    // 在这里定义您的 actions (可以包含异步操作，通过 commit mutations 更改状态)
    // 例如: login({ commit }, credentials) { /* ... api call ... */ commit('SET_USER', userData); commit('SET_TOKEN', token); }
  },
  getters: {
    // 在这里定义您的 getters (用于从 state派生出一些状态)
    // 例如: isAuthenticated: state => !!state.token,
    // currentUser: state => state.user
  },
  modules: {
    // 如果您的 store 比较复杂，可以将其拆分为模块
  }
}) 